import React, { memo } from 'react';

import { Button } from 'antd';

type TableOptionsItem = {
  icon?: string;
  label: string;
  callback: (...args: any[]) => any;
  disabled?: boolean;
  color?: 'default' | 'dashed' | 'primary' | 'text' | 'link';
};

interface IProps {
  items: number;
  options: Array<TableOptionsItem>;
  style?: React.CSSProperties;
}

const TableOptions = ({ items, options, style }: IProps) => {
  if (!items) {
    return null;
  }

  return (
    <div
      className='bg-primary-bg text-primary absolute top-[-52px] left-0 z-2 flex w-full items-center justify-between gap-4 rounded-t px-9 py-3'
      style={{ ...style }}
    >
      <div className='flex shrink-0 items-center'>{`${items} ${items > 1 ? 'selecionados' : 'selecionado'}`}</div>

      <div className='flex flex-wrap items-center justify-end gap-2'>
        {options.map((opt, i) => (
          <Button
            size='small'
            type={opt.color ?? 'text'}
            onClick={() => opt.callback()}
            key={`option-${i}`}
            disabled={opt.disabled}
            icon={
              opt.icon ? (
                <span className='material-icons align-middle text-sm! leading-none'>{opt.icon}</span>
              ) : undefined
            }
          >
            {opt.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default memo(TableOptions);
